import styled from 'styled-components';

export const StyledPairingView = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
